export default "__VITE_ASSET__fFJj4UYa__"